<form [formGroup]="clientForm" class="client-form">
  <div class="client-form__hero">
    <div class="min-w-0">
      <p class="client-form__eyebrow">{{ clientForm.get('id')?.value ? 'Edycja klienta' : 'Nowy klient' }}</p>
      <h3 class="client-form__title">
        {{ clientForm.get('id')?.value ? 'Doprecyzuj dane klienta' : 'Uzupełnij profil klienta' }}
      </h3>
    </div>
  </div>

  <div class="client-form__sections">
    <section class="client-form__section client-form__section--primary">
      <div class="client-form__section-header">
        <div>
          <p class="client-form__section-kicker">Podstawy</p>
          <h4 class="client-form__section-title">Nazwa klienta</h4>
        </div>
        <span class="client-form__pill">Wymagane</span>
      </div>

      <div class="client-form__field">
        <app-label [for]="'name'" [text]="'Nazwa'" [required]="true" [hasError]="hasError('name')"></app-label>
        <input
          pInputText
          id="name"
          formControlName="name"
          class="w-full"
          placeholder="Wpisz nazwę klienta"
          [class.ng-invalid]="hasError('name')"
        />
        <app-input-error-message
          [hasError]="hasError('name')"
          [errorMessage]="getErrorMessage('name') ?? ''"
        ></app-input-error-message>
      </div>
    </section>

    <section class="client-form__section">
      <div class="client-form__section-header">
        <div>
          <p class="client-form__section-kicker">Kontakt</p>
          <h4 class="client-form__section-title">Telefon i email</h4>
        </div>
        <span class="client-form__pill client-form__pill--muted">Opcjonalne</span>
      </div>

      <div class="client-form__field-grid">
        <div class="client-form__field">
          <app-label [for]="'phone'" [text]="'Telefon'" [hasError]="hasError('phone')"></app-label>
          <input
            pInputText
            id="phone"
            formControlName="phone"
            class="w-full client-form__contact-input"
            placeholder="+48123123123"
            [class.ng-invalid]="hasError('phone')"
          />
          <app-input-error-message
            [hasError]="hasError('phone')"
            [errorMessage]="getErrorMessage('phone') ?? ''"
          ></app-input-error-message>
        </div>

        <div class="client-form__field">
          <app-label [for]="'email'" [text]="'Email'" [hasError]="hasError('email')"></app-label>
          <input
            pInputText
            id="email"
            formControlName="email"
            type="email"
            class="w-full client-form__contact-input"
            placeholder="kontakt@firma.pl"
            [class.ng-invalid]="hasError('email')"
          />
          <app-input-error-message
            [hasError]="hasError('email')"
            [errorMessage]="getErrorMessage('email') ?? ''"
          ></app-input-error-message>
        </div>
      </div>
    </section>

    <section class="client-form__section client-form__section--note">
      <div class="client-form__section-header">
        <div>
          <p class="client-form__section-kicker">Kontekst</p>
          <h4 class="client-form__section-title">Notatka</h4>
        </div>
        <span class="client-form__pill client-form__pill--soft">Opcjonalne</span>
      </div>

      <div class="client-form__field">
        <app-label [for]="'note'" [text]="'Notatka'" [hasError]="hasError('note')"></app-label>
        <textarea
          pInputTextarea
          id="note"
          formControlName="note"
          rows="5"
          class="w-full"
          placeholder="Dodatkowe informacje o kliencie, preferencjach lub ustaleniach"
          [class.ng-invalid]="hasError('note')"
        ></textarea>
        <app-input-error-message
          [hasError]="hasError('note')"
          [errorMessage]="getErrorMessage('note') ?? ''"
        ></app-input-error-message>
      </div>
    </section>
  </div>
</form>
